var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"actualidad--view actualidad"},[_c('intro'),_vm._v(" "),_c('noticias'),_vm._v(" "),_c('videos'),_vm._v(" "),_c('twitter'),_vm._v(" "),_c('otras-secciones',{attrs:{"data":['sala_prensa','catalogo']}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-112f6186","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/actualidad.vue
// module id = null
// module chunks = 